import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.match";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import generateId from '../../lib/generateId';
import sizePropTypes from '../../prop-types/Size';
import { noop } from '../../utils';
import styles from './InputGroup.css';
var cx = classnames.bind(styles);

function passesMask(value, mask) {
  // Empty string is fine because users will need to clear out the field
  if (!value && value !== '') {
    return false;
  }

  if (!mask || mask && value === '') {
    return true;
  }

  return value.match(mask);
} // TODO: implement required and size props


export default function Input(_ref) {
  var bordered = _ref.bordered,
      caption = _ref.caption,
      className = _ref.className,
      error = _ref.error,
      id = _ref.id,
      inline = _ref.inline,
      label = _ref.label,
      mask = _ref.mask,
      onChange = _ref.onChange,
      required = _ref.required,
      size = _ref.size,
      value = _ref.value,
      type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["bordered", "caption", "className", "error", "id", "inline", "label", "mask", "onChange", "required", "size", "value", "type"]);

  var _useState = useState(passesMask(value, mask) ? value : ''),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var htmlFor = useMemo(function () {
    return id || generateId();
  }, [id]);
  useEffect(function () {
    // Import date input polyfill only if input type is set to be "date"
    if (type === 'date') {
      // eslint-disable-next-line global-require
      require('date-input-polyfill-react');
    }
  }, [type]);
  useEffect(function () {
    if (passesMask(value, mask)) {
      setInputValue(value);
    }
  }, [value, mask]);

  function handleChange(e) {
    var targetValue = e.target.value;

    if (passesMask(targetValue, mask)) {
      setInputValue(targetValue);
      onChange(e);
    } else {
      e.preventDefault();
    }
  }

  var captionContent = error || caption;
  var inputClasses = cx('input', {
    bordered: bordered,
    labelled: !!label,
    filled: !!inputValue || !!rest.defaultValue,
    dateInput: type === 'date'
  }, className);
  return React.createElement(React.Fragment, null, captionContent && React.createElement("span", {
    className: cx('caption', {
      error: error
    })
  }, captionContent), React.createElement("input", _extends({
    className: inputClasses,
    id: htmlFor,
    onChange: handleChange,
    required: required,
    type: type,
    value: inputValue
  }, rest)), label &&
  /* eslint-disable-next-line jsx-a11y/label-has-for */
  React.createElement("label", {
    className: cx('label'),
    htmlFor: htmlFor
  }, label));
}
Input.propTypes = {
  /** Boolean to set box-shadow on element */
  bordered: PropTypes.bool,

  /** Text displayed underneath the input */
  caption: PropTypes.string,

  /** Class name to apply to component */
  className: PropTypes.string,

  /** Error displayed underneath the input */
  error: PropTypes.string,

  /** Id for input element  */
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Boolean allowing input to be displayed inline */
  inline: PropTypes.bool,

  /** String value to be displayed inside the input as a label/input name */
  label: PropTypes.string,

  /** Regex to filter acceptable input values */
  mask: PropTypes.instanceOf(RegExp),

  /** Change handler */
  onChange: PropTypes.func,

  /** boolean value to indicate if input is required or not */
  required: PropTypes.bool,

  /** String that represents size of input */
  size: sizePropTypes,

  /** Initial value to set in the input */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Type applied to the input */
  type: PropTypes.string
};
Input.defaultProps = {
  bordered: true,
  caption: undefined,
  className: undefined,
  error: undefined,
  id: undefined,
  inline: false,
  label: undefined,
  mask: undefined,
  onChange: noop,
  size: undefined,
  required: undefined,
  value: undefined,
  type: 'text'
};